import { TFunction } from 'i18next'

import { Body2, Caption1 } from '@ui/Typography'

import { Box } from '@shared/components/Box'

export const getDateTimeFormat = (rawDateFormat?: string) => {
  const baseFormat = rawDateFormat ?? 'dd/MM/yyyy'
  const dateFormatParts = baseFormat.split(' ')
  const hasTime = dateFormatParts.includes('HH:mm:ss')
  return hasTime ? baseFormat : [...dateFormatParts, 'HH:mm:ss'].join(' ')
}

export const DateTime = ({ date, time, t }: { date: string; time: string; t: TFunction }) => {
  if (!date && !time) {
    return t('N/A')
  }

  return (
    <Box flex direction='column'>
      <Body2 color='text-high-em'>{date ?? '-'}</Body2>
      <Caption1 color='text-med-em'>{time ?? '-'}</Caption1>
    </Box>
  )
}
